import React from 'react'

const TestDataCard = () => {
    return (
        <div className="card-container bg-layout border border-layout-border rounded-lg p-3 gap-4">
            <div className="inner-section flex flex-col gap-4">
                <div className="top-section text-report-heading font-semibold text-base"><h2>
                    Total Tests</h2></div>

                <div className="middle-section">
                    <div className="inner-middle flex items-center gap-2">                    <h1 className='text-color-gray-light text-2xl font-semibold'>252</h1>  <span className='text-filter-color font-normal text-xs'>(280)</span>
                    </div>
                    <span className='text-filter-color font-normal text-xs'>20% from last period</span>
                </div>

                <div className="bottom-section">
                    <span className='text-filter-color font-normal text-xs'>The Total Tests run in the given period</span>
                </div>
            </div>
        </div>
    )
}

export default TestDataCard